import cookies from 'js-cookie'
import { MutationTree } from 'vuex'
import { AuthState, User } from './types'

export const mutations: MutationTree<AuthState> = {
  login (state: AuthState, token: string): void {
    state.token = token
    state.certified = true

    cookies.set('token', token)
  },

  logout (state: AuthState): void {
    state.user = {}
    state.token = ''
    state.certified = false

    cookies.remove('token')
  },

  refreshProfile (state: any, user: User): void {
    state.user = user
  }
}
